import Image from "next/legacy/image";
import brewingBanner from "../public/img/brew/brewing-banner.png";
import brewRules from "../public/img/brew/brew-rules.png";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}

export default function BrewRules() {
  return (
    <div className="pt-[33px] text-white font-medium text-[20px] leading-[32px] w-full">
      <style>{`
        body {
          background-color: black;
          min-width: 640px;
        }
      `}</style>
      <div className="mx-auto w-[640px] bg-[#191616] pb-[100px]">
        <Image src={brewingBanner} layout="responsive" />
        <div className="px-[54px]">
          <div className="mt-[60px] mb-[30px]">
            <Image src={brewRules} width={106} height={64} />
          </div>
          <div>
            1. Brewing is only for revealed Cheers (Cheers UP Official).
            <br />
            2. When Cheers is brewing, it will have the total and current
            brewing time which accumulated as points.
            <br />
            3. The brewing Cheers will remain in your wallet and freely transfer
            with its points. But it doesn't support transfer which is not the
            official transfer way.
            <br />
            4. The transfer of brewing Cheers need to be completed on the
            official website through the official contract, providing the
            brewing Cheers with a safer environment and reducing fraud risk.
            <br />
            5. If you want to trade via OpenSea and other platforms, you must
            first un-brew on the official website. Otherwise, the transaction
            cannot be successful.
            <br />
            6.When Cheers has been listed on Opensea or other platforms with a
            price that is nearly or cheaper than the floor price, we will remove
            the Cheers from the brew.
          </div>
          <div className="mt-[30px] font-cn font-normal">
            1. 酿造仅针对reveal后的Cheers，即 Cheers UP Official；
            <br />
            2. 进入酿造状态，会有累计总酿造时间和单次酿造时间作为积分；
            <br />
            3. 酿造状态的 Cheers
            仍在您的钱包内不影响使用，可转移，积分会随着一同转移；但不支持（官方转移功能以外的）链上转移操作；
            <br />
            4. 转移需通过官方合约在官网上完成，这也使进入酿造状态的 Cheers
            更安全，降低了被盗的可能性；
            <br />
            5. 若想在 OpenSea 等平台交易，需先在官网解除酿造，否则无法交易成功；
            <br />
            6.
            酿造状态下在OpenSea等平台挂单低于或接近地板价时，将在一段时间内被解除酿造。
          </div>
        </div>
      </div>
    </div>
  );
}
